/* ============================================================================
   TNE Perfil — JS para renderizar o gráfico de pedidos por mês e a lista
   de top produtos. Lê window.tnePerfilData injectado em tne-perfil.liquid.

   Sem dependências externas — bar chart é DOM puro com altura proporcional.
   ============================================================================ */

(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', init);

  function init() {
    var data = window.tnePerfilData;
    if (!data) return;

    renderChart(data.orders_by_month || []);
    renderTopProducts(data.line_items || []);
  }

  /* ──────── Gráfico: nº de pedidos por mês (últimos 12 meses) ──────── */
  function renderChart(orderMonths) {
    var container = document.querySelector('[data-tne-perfil-chart]');
    if (!container) return;

    var counts = aggregateByMonth(orderMonths);
    var months = lastTwelveMonths();
    var max = Math.max.apply(null, months.map(function (m) { return counts[m.key] || 0; }).concat([1]));

    var monthLabels = ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'];

    var html = '';
    var total = 0;
    months.forEach(function (m) {
      var count = counts[m.key] || 0;
      total += count;
      var height = count === 0 ? 0 : Math.max((count / max) * 100, 6);
      var empty = count === 0 ? ' tne-perfil-bar--empty' : '';
      html += [
        '<div class="tne-perfil-bar' + empty + '">',
        '  <span class="tne-perfil-bar__value" style="height:' + height + '%" data-count="' + count + ' pedido' + (count === 1 ? '' : 's') + '"></span>',
        '  <span class="tne-perfil-bar__label">' + monthLabels[m.monthIndex] + '</span>',
        '</div>'
      ].join('');
    });

    container.innerHTML = html;

    var legend = document.querySelector('[data-tne-perfil-chart-legend]');
    var totalEl = document.querySelector('[data-tne-perfil-total]');
    if (legend && totalEl) {
      totalEl.textContent = total + ' pedido' + (total === 1 ? '' : 's') + ' nos últimos 12 meses';
      legend.hidden = false;
    }
  }

  function aggregateByMonth(months) {
    var out = {};
    months.forEach(function (m) {
      if (!m) return;
      out[m] = (out[m] || 0) + 1;
    });
    return out;
  }

  function lastTwelveMonths() {
    var now = new Date();
    var out = [];
    for (var i = 11; i >= 0; i--) {
      var d = new Date(now.getFullYear(), now.getMonth() - i, 1);
      var year = d.getFullYear();
      var month = d.getMonth() + 1;
      var key = year + '-' + (month < 10 ? '0' + month : month);
      out.push({ key: key, year: year, monthIndex: d.getMonth() });
    }
    return out;
  }

  /* ──────── Top produtos comprados ──────── */
  function renderTopProducts(lineItems) {
    var container = document.querySelector('[data-tne-perfil-top]');
    if (!container) return;

    var byTitle = {};
    lineItems.forEach(function (li) {
      if (!li || !li.title) return;
      var key = li.title;
      if (!byTitle[key]) {
        byTitle[key] = { title: li.title, qty: 0, image: li.image, url: li.url };
      }
      byTitle[key].qty += Number(li.qty) || 1;
      if (!byTitle[key].image && li.image) byTitle[key].image = li.image;
      if (!byTitle[key].url && li.url) byTitle[key].url = li.url;
    });

    var top = Object.keys(byTitle)
      .map(function (k) { return byTitle[k]; })
      .sort(function (a, b) { return b.qty - a.qty; })
      .slice(0, 5);

    if (top.length === 0) {
      container.innerHTML = '<li class="tne-perfil__empty">Ainda sem dados.</li>';
      return;
    }

    var html = top.map(function (p) {
      var image = p.image
        ? '<img class="tne-perfil__top-image" src="' + escapeAttr(p.image) + '" alt="" loading="lazy">'
        : '<span class="tne-perfil__top-image tne-perfil__top-image--placeholder" aria-hidden="true"></span>';
      var qtyLabel = p.qty + ' unidade' + (p.qty === 1 ? '' : 's');
      var inner = [
        image,
        '<div class="tne-perfil__top-body">',
        '  <span class="tne-perfil__top-title">' + escapeHtml(p.title) + '</span>',
        '  <span class="tne-perfil__top-qty">' + qtyLabel + '</span>',
        '</div>'
      ].join('');
      if (p.url) {
        return '<li><a class="tne-perfil__top-item" href="' + escapeAttr(p.url) + '">' + inner + '</a></li>';
      }
      return '<li class="tne-perfil__top-item">' + inner + '</li>';
    }).join('');

    container.innerHTML = html;
  }

  function escapeHtml(str) {
    return String(str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function escapeAttr(str) {
    return escapeHtml(str);
  }

})();
